"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var unfetch_1 = __importDefault(require("unfetch"));
var subscriptions_api_1 = require("../../misc/subscriptions-api");
exports.default = (function (_a) {
    var daysAhead = _a.daysAhead, possibleChoices = _a.possibleChoices, possibleNighttimeChoices = _a.possibleNighttimeChoices, addOns = _a.addOns, discountAddOns = _a.discountAddOns;
    return __awaiter(void 0, void 0, void 0, function () {
        var bundlerSkuLookup, _b, _c, _d, variants, key, i, variant, sku, newLookup, clientArgs, res, futureQuantities, variantsMadeUnavailable, _e, _f, _g, sku, quantity, _h, _j, _k, key, index, variant;
        var e_1, _l, e_2, _m, e_3, _o;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    bundlerSkuLookup = {};
                    try {
                        for (_b = __values([
                            { variants: possibleChoices, key: 'possibleChoices' },
                            { variants: possibleNighttimeChoices, key: 'possibleNighttimeChoices' },
                            { variants: addOns === null || addOns === void 0 ? void 0 : addOns.map(function (a) { return a[1]; }), key: 'addOns' },
                            { variants: discountAddOns === null || discountAddOns === void 0 ? void 0 : discountAddOns.map(function (a) { return a[1]; }), key: 'discountAddOns' },
                        ]), _c = _b.next(); !_c.done; _c = _b.next()) {
                            _d = _c.value, variants = _d.variants, key = _d.key;
                            if (variants) {
                                for (i = 0; i < variants.length; i++) {
                                    variant = variants[i];
                                    // we only care about checking future quantities for items that are currently in stock
                                    // otherwise we will waste a lot of bandwidth and database resources
                                    if (typeof variant.inventory_quantity !== 'undefined' && variant.inventory_quantity > 0) {
                                        sku = variant.sku.toUpperCase();
                                        newLookup = bundlerSkuLookup[sku] || [];
                                        newLookup.push([key, i]);
                                        bundlerSkuLookup[sku] = newLookup;
                                    }
                                }
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_l = _b.return)) _l.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    clientArgs = (0, subscriptions_api_1.getClientArgs)({ path: '/get-future-quantities' });
                    return [4 /*yield*/, (0, unfetch_1.default)(clientArgs.uri, {
                            body: JSON.stringify({
                                skus: Object.keys(bundlerSkuLookup),
                                daysAhead: daysAhead,
                            }),
                            method: 'POST',
                            headers: __assign(__assign({}, clientArgs.headers), { 'Content-Type': 'application/json' }),
                        })];
                case 1:
                    res = _p.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    futureQuantities = (_p.sent());
                    variantsMadeUnavailable = [];
                    try {
                        // now we can use our efficient lookup map to update the quantity for each sku
                        for (_e = __values(Object.entries(futureQuantities)), _f = _e.next(); !_f.done; _f = _e.next()) {
                            _g = __read(_f.value, 2), sku = _g[0], quantity = _g[1];
                            try {
                                for (_h = (e_3 = void 0, __values(bundlerSkuLookup[sku] || [])), _j = _h.next(); !_j.done; _j = _h.next()) {
                                    _k = __read(_j.value, 2), key = _k[0], index = _k[1];
                                    variant = void 0;
                                    if (key === 'possibleChoices')
                                        variant = possibleChoices[index];
                                    else if (key === 'possibleNighttimeChoices' && possibleNighttimeChoices)
                                        variant = possibleNighttimeChoices[index];
                                    else if (key === 'addOns' && addOns)
                                        variant = addOns[index][1];
                                    else if (key === 'discountAddOns' && discountAddOns)
                                        variant = discountAddOns[index][1];
                                    if (variant) {
                                        if (typeof quantity === 'number' && quantity <= 0)
                                            variantsMadeUnavailable.push(variant);
                                        variant.future_inventory_quantity = quantity;
                                    }
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (_j && !_j.done && (_o = _h.return)) _o.call(_h);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_m = _e.return)) _m.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    console.log('Low stock variants:\n' +
                        variantsMadeUnavailable
                            .map(function (v) { return v.name; })
                            .sort()
                            .join('\n'));
                    return [2 /*return*/];
            }
        });
    });
});
